"use strict";

const MedicationCtrl = function(){
  var ctrl = this;

  ctrl.$onInit = function(){
  };

  ctrl.isEmpty = function(obj){
    for (var item in obj) {
      if (obj.hasOwnProperty(item)) {
        return false;
      }
    }
    return true;
  };
};

MedicationCtrl.$inject = [];


module.exports = {
  bindings: {
    'patient': '<'
  },
  template: require('./medications.html'),
  controller: MedicationCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/medications/medications.component.js